import React, { useRef, useState, useEffect} from 'react';
import CustomScrollBar from 'jd-library/CustomScrollBar';

import styles from './checkboxAutosuggestStyle.scss';

export default function CheckBoxAutosuggest(props) {
    const inputRef = useRef()
    const labelRef = useRef();
    
    const {
        suggestions = [],
        onChange = () => {},
        as="basic"
    } = props; 

    const [suggestionPills, setsuggestionPills] = useState([]); 
    const [isToggle, setIsToggle] = useState(false)
    const [input, setinput] = useState({}); 
    const [selectedPills, setselectedPills] = useState([]);
    const isDropdownVariant = as.toLowerCase() =="dropdown";
    const [isFocused, setFocus] = useState(false); 

    useEffect(()=>{ 
        if(suggestions.length){
            sortSuggestionsByChecked(suggestions);
        }
     }, [suggestions])

    useEffect(() => {
        if(isDropdownVariant){
            document.addEventListener("click", (e) => {
                if(e.target.classList.contains("checkbox-autosuggest-wrap")){
                    e.preventDefault();
                    return
                }else{
                    setIsToggle(false);                  
                }
            },true)
        }

        return () => {
            if(isDropdownVariant){
                document.removeEventListener('click', () => {})
            }
        }
    },[]);
    let backSpaceCount = 0; 

    function sortSuggestionsByChecked(suggestions){
    const isSelectedPills = suggestions.filter(s => s.checked);
    const nonSelectedPills = suggestions.filter(s => !s.checked);

    setsuggestionPills(nonSelectedPills);
    setselectedPills(isSelectedPills);
    }

    function focusInput(type) {
        switch(type){
            case "focus":
                inputRef.current.focus();
                setFocus(true);
                setIsToggle(true);
                break;
            case "blur": 
                setFocus(false);
                break;
            default:
                break;
        }
    }

    function toggleSuggestion(index, { payload, type }){
        
        switch(type){
            case "SELECT":{

                // const pills = [...suggestionPills].map((pill) => {
                //     if(pill.key === payload.key && pill.label === payload.label){
                //         pill.checked = true;
                //     }
                //     return pill;
                // });
                const pills = Object.assign([], suggestionPills)
                const selectedPill = pills.splice(index, 1);
                
                selectedPill[0].checked = true;
                setselectedPills([...selectedPills, ...selectedPill]);
                setsuggestionPills(pills);
                break;
            }
            case "REMOVE": {

                // const pills  = [...suggestionPills].map((pill) => {
                //     if(pill.key === payload.key && pill.label === payload.label){
                //         pill.checked = false;
                //     }
                //     return pill;
                // });

                // setsuggestionPills(pills);

                const pills = Object.assign([], selectedPills);
                const suggestionPill = pills.splice(index, 1);
                suggestionPill[0].checked = false;
                setselectedPills(pills);
                setsuggestionPills([...suggestionPills, ...suggestionPill]);
                break;
            }
            case "EDIT":{

                setInputWidth(payload.label);
                toggleSuggestion(index,{ payload, type: "REMOVE"});
                setinput(payload); 

                break;
            }
            default:
                break;
        }

        onChange(payload, [...suggestionPills, ...selectedPills]);
        focusInput("focus");
    }

    function inputOnChange(e){
        const {
            target: {
                value
            }
        } = e;  
        setInputWidth(value);
        setinput({
            label: value,
            key: null, 
            checked:false
        });
    }

    function setInputWidth(value, fixedWidth) {

        const widthCalc = ((value.length + 1) * 8);

        if(widthCalc >=  (labelRef.current.offsetWidth - 20)) fixedWidth = (labelRef.current.offsetWidth - 20);

        inputRef.current.style.width = (fixedWidth || widthCalc) + 'px';
    }

    function updateOnEnter(pills){
        sortSuggestionsByChecked(pills);
                
        setInputWidth(input.label, 8);
        onChange(input, pills);
        
        setinput({label: "", key: null});
        focusInput("focus");
    }

    function handleOnKeyUp(e){
        const { keyCode } = e;

        const ENTER_KEY = 13;
        const BACK_SPACE = 8; 
        
        if(BACK_SPACE == keyCode){
            (!input.label || !input.label.length) ? backSpaceCount++ : backSpaceCount = 0; 
        }

        if(ENTER_KEY == keyCode && input && input.label && input.label.length){
            const pills = [...suggestionPills,...selectedPills];
            
            if(!pills.some(p => p.label === input.label)){

                input.checked = true;
                pills.push(input);
                updateOnEnter(pills);
                
            }
            
            if(pills.some(p => p.label === input.label && !p.checked)){
                const index = pills.findIndex((i) => i.label === input.label);
                const pill = pills.splice(index, 1);
                pill[0].checked = true;

                // const isAlreadyPresent = pills.map(pill => {
                //     if(pill.label === input.label){
                //         pill.checked = true;
                //     }
                //     return pill; 
                // });

                updateOnEnter([...pills, ...pill]);
                 
            }
            
        }

        if(BACK_SPACE === keyCode && !input.label && selectedPills.filter(i => i.checked).length && backSpaceCount >= 2){
            
            const backSpacePills = [...selectedPills];
            const backSpaceLastPill = backSpacePills.pop();
            backSpaceLastPill.checked = false;
            setselectedPills(backSpacePills);
            setsuggestionPills([...suggestionPills,backSpaceLastPill]);
            setinput(backSpaceLastPill);
            setInputWidth(backSpaceLastPill.label); 
            

            onChange(backSpaceLastPill, [...suggestionPills,...selectedPills]); 
            backSpaceCount = 0;
        }
    }

    const Component = isDropdownVariant ? CustomScrollBar  : React.Fragment;
    const componentOptions = isDropdownVariant ? {autoHide: false} : {};

    return (
        <div className={styles["checkbox-autosuggest-wrap"]} data-checkBoxAutosuggest>
            <div className={`${styles["checkbox-suggestion-inputbox"]} ${isFocused? styles["isFocused"] : ""} ${selectedPills.length || isFocused ? styles["label-active"] : ""} ${isDropdownVariant ? styles["v_dropdown-input-wrap"]: ""}`} ref={labelRef} onClick={() => focusInput("focus")} onBlur={() => focusInput("blur")}>
                <div className={styles["checkbox-suggestion-label"]}>{props.label || ""}</div>
                <div className={styles["checkbox-suggestion-wrap"]}>
                    <ul>
                        {
                            selectedPills.map((pill,index)=> {
                                return (
                                    <li key={`${pill.label}_${index}`}>
                                        <span className={styles["default-suggestion-text"]}>
                                            <span className={styles["label-text"]} onClick={() => toggleSuggestion(index, {type: "EDIT",payload: pill})}>
                                                {pill.label}
                                            </span>
                                            <span className={`${styles["icon-cross"]} icon-HDRcross`} onClick={() => toggleSuggestion(index, {type: "REMOVE",payload: pill})} ></span>
                                        </span>
                                    </li>
                                ) || null
                            }) 
                        }
                        <li className={styles["checkbox-input-wrap"]}>
                            <input style={{width: "8px"}} ref={inputRef} value={input.label || ""} onKeyUp={handleOnKeyUp} onChange={inputOnChange} />
                        </li>
                    </ul>
                </div> 
            </div>
            <div className={`${styles["checkbox-autosuggestions-wrap"]} ${isDropdownVariant ? styles["v_dropdown-wrap"] : ""}`} style={isDropdownVariant ? {display: isToggle ? "block":"none"}: {}}>
                <Component {...componentOptions}>
                    <ul>
                        {
                            isDropdownVariant && input.label && (<li key="customInput">
                                <span className={styles["default-suggestion-text"]} onClick={() => handleOnKeyUp({keyCode: 13})}>
                                    <span>
                                        {input.label}
                                    </span>
                                </span>
                            </li>)
                        }
                        {
                            suggestionPills.map((suggestionPill, index) => {
                                return (
                                        <li key={`${suggestionPill.label}_${index}`}>
                                            <span className={styles["default-suggestion-text"]} onClick={() => toggleSuggestion(index, {type: "SELECT",payload: suggestionPill})}>
                                                <span>
                                                    {suggestionPill.label}
                                                </span>
                                            </span>
                                        </li>
                                )
                            })
                        }
                    </ul>
                </Component>
            </div>
        </div>
    )
}